import { z } from "zod";
export const BillingIntervalSchema = z.enum(["daily", "monthly", "yearly"]);
export const PriceSchema = z.object({
    stripePriceId: z.string(),
    stripeProductId: z.string(),
    stripeProductName: z.string().optional(),
    stripeProductDescription: z.string().optional(),
    active: z.boolean(),
    amount: z.number(),
    interval: BillingIntervalSchema,
    isPricePerCreator: z.boolean().optional(),
    isTrial: z.boolean().optional(),
    isHidden: z.boolean().optional(),
    minimumSeats: z.number().optional(),
    legacyVersion: z.string().optional(),
    featuresSet: z.string().optional(),
    stripeProductFeatures: z.array(z.string()).optional(),
    stripeProductAdditionalFeatures: z.array(z.string()).optional(),
    seatType: z.enum(["Full", "Builder"]).optional(),
    monthlyCreditGrant: z.number().optional(),
});
